module.exports = __webpack_public_path__ + "img/info-white.87cb2e4d.svg";